import React from 'react';
import MuiCard, { CardProps as MuiCardProps } from '@mui/material/Card';

/**
 * A wrapper component for the MUI Card component.
 *
 * @param {MuiCardProps} props - The properties passed to the MUI Card component.
 * @returns {React.ReactElement} The rendered MUI Card component with the passed properties.
 *
 * @category Component
 */
export const Card = (props: MuiCardProps): React.ReactElement => {
  return <MuiCard {...props}>{props.children}</MuiCard>;
};
